var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-fullheight is-dark is-bold"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("Game not available")]),_c('h2',{staticClass:"subtitle"},[_vm._v("Currently There is no game available right now.")])])])])
}]

export { render, staticRenderFns }